import React from 'react';
import {
    Box,
    Container,
    Typography,
    Link,
    useTheme,
} from '@mui/material';

const Footer: React.FC = () => {
    const theme = useTheme();
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                mt: 'auto',
                py: 2,
                px: 2,
                backgroundColor: 'transparent',
                borderTop: 'none',
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 2,
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            fontSize: '0.75rem',
                            opacity: 0.7,
                        }}
                    >
                        © {currentYear} LOADOC. All rights reserved.
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Link
                            href="#"
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                textDecoration: 'none',
                                fontSize: '0.75rem',
                                opacity: 0.7,
                                '&:hover': {
                                    color: theme.palette.primary.main,
                                    textDecoration: 'underline',
                                    opacity: 1,
                                },
                            }}
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            href="#"
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                textDecoration: 'none',
                                fontSize: '0.75rem',
                                opacity: 0.7,
                                '&:hover': {
                                    color: theme.palette.primary.main,
                                    textDecoration: 'underline',
                                    opacity: 1,
                                },
                            }}
                        >
                            Terms of Service
                        </Link>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer; 